<template>
  <div
    :class="$vuetify.breakpoint.mdAndUp ? 'py-4 pl-6' : 'py-4 px-6'"
    class=""
  >
    <YourOrder
      :loading="loading"
      :showPixScreen="showPixScreen"
      @createOrder="$emit('createOrder')"
      @purchase="$emit('purchase')"
    />
    <Map v-if="mapUrl && $route.name === 'Cart'" :mapUrl="mapUrl" />
  </div>
</template>

<script>
import YourOrder from "./YourOrder.vue";
import Map from "./Map.vue";
import { mapGetters } from "vuex";
export default {
  props: ["loading", "showPixScreen"],
  components: { YourOrder, Map },
  computed: {
    ...mapGetters(["eventDetails"]),
    mapUrl() {
      const map = this.eventDetails.midias.find(
        (midia) => midia.codigo_midia === 2 && midia.ativo === 1
      );
      return map ? map.url : false;
    },
  },
};
</script>
